module.exports = __webpack_public_path__ + "img/10.672b0073.webp";